import { useState } from 'react';
import useStrategyData from '../../hooks/useStrategyData';
import StrategyCard from '../../components/StrategyCard';
import StrategyModal from '../../components/StrategyModal';
import AccountSwitcher from '../../components/AccountSwitcher';
import Navbar from '../../components/Navbar';
import SummaryBar from '../../components/SummaryBar/index.jsx';
import '../../styles.css';

const StrategyHistory = () => {
  const [accountId, setAccountId] = useState('1');
  const [inputAccountId, setInputAccountId] = useState('1');
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { filteredStrategies, logoMap, loading } =
    useStrategyData(accountId, false); // `false` = older than 24h

  const handleAccountChange = () => {
    const trimmed = inputAccountId.trim();
    const valid = /^[a-zA-Z0-9]{1,6}$/.test(trimmed);

    if (!valid) {
      alert('❗ ID może zawierać tylko litery i cyfry, maksymalnie 6 znaków.');
      return;
    }

    setAccountId(trimmed);
  };

  return (
    <>
      <Navbar />
      {loading ? (
        <div className="container history-container cards-wrap">
        ⏳ Ładowanie strategii...</div>
      ) : filteredStrategies.length === 0 ? (
        <div className="container history-container cards-wrap">
        ⚠️ Nie masz żadnych strategii!</div>
      ) : (
        <>
      <SummaryBar
        deposit={filteredStrategies.reduce((sum, s) => sum + parseFloat(s.deposit || 0), 0)}  
        invested={filteredStrategies.reduce((sum, s) => sum + parseFloat(s.usd_in_trade || 0), 0)}
        profit={filteredStrategies.reduce((sum, s) => sum + parseFloat(s.withdrawable_profit || 0), 0)}
        roi={
          filteredStrategies.length
            ? filteredStrategies.reduce((sum, s) => sum + parseFloat(s.annual_roi || 0), 0) / filteredStrategies.length
            : 0
        }
      />

          <div className="container cards-wrap">
            {filteredStrategies.map(strategy => {
              const symbol = typeof strategy.symbol === 'string'
                ? strategy.symbol.split('/')[0].toLowerCase()
                : '';

              const logoUrl = logoMap[symbol] || '';

              return (
                <StrategyCard
                  key={strategy.strategyId}
                  strategy={{...strategy, strategy_type: 'HISTORY'}}
                  logoUrl={logoUrl}
                  onClick={() => {
                    setSelectedStrategy({ ...strategy, _logoUrl: logoMap[symbol] || '' });
                    setShowModal(true);
                  }}
                />
              );
            })}
          </div>

          {showModal && (
            <StrategyModal
              strategy={{...selectedStrategy, strategy_type: 'HISTORY'}}
              logoUrl={logoMap[selectedStrategy.symbol.split('/')[0].toLowerCase()]}
              onClose={() => setShowModal(false)}
            />
          )}
        </>
      )}

      <AccountSwitcher
        value={inputAccountId}
        onChange={setInputAccountId}
        onSubmit={handleAccountChange}
      />
    </>
  );
};

export default StrategyHistory;
